import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../../app/hooks";
import { AssignmentCancellation } from "../../../talents/talentAPI";

type Props = {
  cancellation?: AssignmentCancellation;
};

//  If assignment has been cancelled, show the reason for cancellation
const AssignmentCancellationBar = ({ cancellation }: Props) => {
  const { t } = useTranslation();

  const localized = useAppSelector((state) => state.localized);
  const translatedCancellationReasons = localized.assignmentCancelReason;

  if (!cancellation) return null;

  return (
    <Box
      sx={{
        backgroundColor: "#FF9600",
        padding: "4px 24px 4px 24px",
        fontSize: "14px",
        margin: "0px -16px 12px -16px",
      }}
    >
      {`${t("talentProfile:assignmentIsCancelled")}: ${
        translatedCancellationReasons[cancellation?.reason] ||
        cancellation?.reason ||
        ""
      }`}
    </Box>
  );
};

export default AssignmentCancellationBar;
